import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { newServicesAction } from '../../_actions';
import { productAction } from '../../_actions/product.action';
import { useDispatch } from 'react-redux';
import toast from '../shared/Toast';

function MessagePopupBody(props) {
  const [inputValue, setInputValue] = useState('');
  const [errors, setErrors] = useState('')
  const dispatch = useDispatch()
  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    setErrors('')

    if(e.target.value==''){
      setErrors('Category is required')
    }
  };

  const handleSave = (type) => {

    if((inputValue != undefined) && (inputValue !='')){
      console.log("input_value---", inputValue)
      console.log("Save button clicked",type);
      
      // Check if submitFunction is defined and call it for any add or edit operation
      if (props.submitFunction) {
        console.log("Calling submitFunction with:", inputValue);
        props.submitFunction(inputValue);
        setInputValue("");
      } else {
        console.log("submitFunction is not defined");
      }

      setErrors('')
    }
    else{
      // Use the message type in the error message
      setErrors(`${props?.message} name is required`)
    }
    
  };

  useEffect(() => {
    setInputValue(props.initialValue); // Set the initial value for editing
  }, [props.initialValue]);

  const handleDelete = (deleted_id,type)=>{
    // debugger
    if(type.startsWith("Delete Category")){
      // Check if we're in the products page or services page
      if (window.location.pathname.includes('/product')) {
        handleDeleteProductCategory(deleted_id);
      } else {
        handleDeleteServiceCategory(deleted_id);
      }
    }
    else if(type.startsWith("Delete Service")){
      handleDeleteService(deleted_id)
    }
    else if(type.startsWith("Delete Product")){
      handleDeleteProduct(deleted_id)
    }
    else{}

  }
  
  const handleDeleteProductCategory = (deleted_id) => {
    // For product categories
    const payload = {
      "categoryId": deleted_id,
    }
    console.log("Deleting product category with payload:", payload);
    
    dispatch(productAction.deleteProductCategory(payload))
      .then((res) => {
        console.log("Product category deleted response:", res);
        if(res?.data?.statusCode === 1) {
          toast.success(res?.data?.responseData?.message || "Category deleted successfully");
          props.onHide();
          
          // Refresh both the product list and categories list to update the UI
          if (props.servicesList) {
            props.servicesList();
          }
          
          // If we're on the products page, also refresh the categories
          // We don't need to force a page reload, just refresh the list
          if (window.location.pathname.includes('/product')) {
            // The servicesList function will update the product list
            if (props.servicesList) {
              props.servicesList();
            }
            
            // Also refresh the categories list
            if (props.listAllCategories) {
              props.listAllCategories();
            }
          }
        } else {
          toast.error(res?.data?.error?.responseMessage || "Failed to delete category");
        }
      })
      .catch((error) => {
        console.error("Error deleting product category:", error);
        toast.error("Failed to delete category");
      });
  }
  
  const handleDeleteServiceCategory = (deleted_id) =>{
    // For service categories
    const payload = {
      "categoryId": deleted_id,
    }
    dispatch(newServicesAction.deleteCategoryData(payload))
      .then((res) => {
        console.log("Service category deleted successfully:", res);
        if(res?.deleteCategory?.statusCode===1) {
          toast.success(res?.deleteCategory?.responseData?.message);
          props.onHide()
       }
       else{
         toast.error(res?.deleteCategory?.error? res?.deleteCategory?.error?.responseMessage : res?.deleteCategory?.responseData?.message);
       }
       props.servicesList()
       
      })
      .catch((error) => {
        console.error("Error delete service category:", error);
      });
  }
  const handleDeleteService = (deleted_id) =>{
    // debugger
    const payload = {
      "commonServiceId": deleted_id,
    }
    dispatch(newServicesAction.deleteServicesData(payload))
      .then((res) => {
        console.log("service deleted successfully:", res);
        if(res?.deleteServices?.statusCode===1) {
          toast.success(res?.deleteServices?.responseData?.message); props.onHide()
       }
       else{
         toast.error(res?.deleteServices?.error? res?.deleteServices?.error?.responseMessage : res?.deleteServices?.responseData?.message);
       }
        props.servicesList()
       
      })
      .catch((error) => {
        console.error("Error delete service:", error);
      });

  }
  const handleDeleteProduct = (deleted_id) =>{
    // debugger
    const payload = {
      "productId": deleted_id,
    }
    dispatch(productAction.deleteProduct(payload))
      .then((res) => {
        console.log("Product deleted successfully:", res);
        if(res?.data?.statusCode === 1) {
          toast.success(res?.data?.responseData?.message || "Product deleted successfully");
          props.onHide();
        }
        else{
          toast.error(res?.data?.error?.responseMessage || "Failed to delete product");
        }
        props.servicesList();
      })
      .catch((error) => {
        console.error("Error deleting product:", error);
        toast.error("Failed to delete product");
      });
  }

  const handleDisabledButton = (deleted_id) =>{
    // debugger
    const payload = {
      "commonServiceId": deleted_id,
    }
    dispatch(newServicesAction.serviceStatusChange(payload))
      .then((res) => {
        console.log("serviceStatusChange successfully:", res);
        if(res?.serviceStatusChange?.statusCode===1) {
          toast.success(res?.serviceStatusChange?.responseData?.message); 
          props.onHide()
       }
       else{
        //  toast.error(res?.deleteServices?.error? res?.deleteServices?.error?.responseMessage : res?.deleteServices?.responseData?.message);
       }
        props.servicesList()
       
      })
      .catch((error) => {
        console.error("Error service StatusChange:", error);
      });
  }


  return (
    <Modal 
        blurClass={props?.blurClass}
        centered={props?.centered}
        show={props?.show} 
        onHide={props?.onHide} 
        backdropClassName={props?.backdropClassName}
        size={props?.size} 
        dialogClassName={props?.dialogClassName} 
        className={props?.className} >
        <Modal.Body className=''>
        {props?.popupType == "delete" &&
         <div className='_delete_popup'>
          {props?.notAssigned != false ?
          <>
           <h4>{props?.message?.heading }</h4>
            <p>{props?.message?.heading?.startsWith("Delete Product") ?
               "Are you sure you want to delete this product? This action cannot be undone." :
               props?.message?.discription}</p>
            <div className="filter-actions text-right">
              <button className="btn btn-outline-dark pl-4 pr-4" onClick={()=>props.onHide()}>{props?.message?.btntext1}</button>
              <button
                className={`btn btn-dark ml-4 pl-4 pr-4 ${props?.message?.heading?.startsWith("Delete Product") ? "" : "_deletebtn"}`}
                onClick={()=>handleDelete(props?.deletedId , props?.message?.heading)}>{props?.message?.btntext2}</button>
            </div>
          </>
          :
          <>
           <h4>{props?.message?.headingAssigned}</h4>
            <p>{props?.message?.discriptionAssigned}</p>
            <div className="filter-actions text-right">
              <button className="btn btn-outline-dark pl-4 pr-4" onClick={()=>props.onHide()}>{props?.message?.btntext1}</button>
              <button className="btn btn-dark ml-4 pl-4 pr-4 _disabled"
               onClick={()=>handleDisabledButton(props?.deletedId)}>Disable</button>
            </div>
          </>
        }
           
         </div>
         }
         {(props.popupType == "edit"  || props.popupType == "add")&&
            <div className="_filter">
              {props.popupType== "edit" ? <h4>Edit {props?.message}</h4> : <h4>New {props?.message}</h4>}
              <div className="filters-popup pt-3">
                <div className="filter-group">
                  <label className='d-block'>{props?.message} Name</label>
                  <input 
                    type="text" 
                    className="form-controls w-100" 
                    name={props?.message+"_name"} 
                    value={inputValue}
                    onChange={handleInputChange}
                  />
                  {errors && <span className="cm_error_msg">{errors}</span>}
                </div>
                <div className="filter-actions text-right mt-5">
                  <button className="btn btn-outline-dark pl-4 pr-4" onClick={()=>props.onHide()}>Cancel</button>
                  <button className="btn btn-dark ml-4 pl-4 pr-4" onClick={()=>handleSave(props.popupType+props?.message)}>Save</button>
                </div>
              </div>
            </div>
          }
        </Modal.Body>
    </Modal>
  )
}

export default MessagePopupBody